import "./NavbarComp.css";
import { defineComponent as c, resolveComponent as n, openBlock as i, createElementBlock as p, createElementVNode as o, createVNode as t, withCtx as _, renderSlot as s } from "vue";
import { IconComp as d } from "./IconComp.js";
import { _ as m } from "./_plugin-vue_export-helper.dad06003.js";
const l = c({
  name: "navbar-comp",
  components: {
    IconComp: d
  },
  props: {
    appName: {
      type: String,
      note: "Name displayed in the left-most section"
    }
  }
});
const v = { class: "navbar not-printed" }, u = { class: "navbar-section" }, f = ["innerHTML"], b = { class: "navbar-section" }, h = { class: "navbar-section" };
function N(e, C, $, g, k, y) {
  const a = n("icon-comp"), r = n("router-link");
  return i(), p("header", v, [
    o("div", u, [
      t(r, {
        to: "/",
        class: "navbar-branding"
      }, {
        default: _(() => [
          t(a, {
            class: "logo",
            icon: "gears"
          }),
          o("div", null, [
            o("span", { innerHTML: e.appName }, null, 8, f)
          ])
        ]),
        _: 1
      })
    ]),
    o("div", b, [
      s(e.$slots, "main-section", {}, void 0, !0)
    ]),
    o("div", h, [
      s(e.$slots, "user-section", {}, void 0, !0)
    ])
  ]);
}
const I = /* @__PURE__ */ m(l, [["render", N], ["__scopeId", "data-v-0745a424"]]);
export {
  I as NavbarComp
};
//# sourceMappingURL=NavbarComp.js.map
